import type { CreatureState, Stage } from '@/domain/creature/types';
import { computeHealth } from '@/domain/care/health';

export type Expression = 'neutral' | 'happy' | 'sad' | 'sick' | 'sleepy' | 'angry' | 'blink';

export function statsToExpression(state: CreatureState, stage: Stage, sleeping: boolean): Expression {
  if (sleeping) return 'sleepy';
  if (stage === 'dead') return 'sad';
  if (state.tantrum) return 'angry';
  if (state.sick) return 'sick';
  const health = computeHealth(state, stage);
  if (health < 30 || state.hunger < 25 || state.happiness < 25) return 'sad';
  if (state.hunger > 70 && state.happiness > 70 && health > 70) return 'happy';
  return 'neutral';
}
